module.exports = __webpack_public_path__ + "public/images/partners/sup-7.a2423abd2ef254ee13e27df22c3e6d75.png";